export default __webpack_public_path__ + "static/media/lp_anuj_k_acharya.1c5775b8.png";